"use client";

import { cn } from "@/utils/cn";

interface SkeletonProps {
  className?: string;
}

/**
 * Reusable Skeleton component with shimmer effect for better perceived performance.
 */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-gray-200/60",
        className
      )}


    />
  );
}

/**
 * Skeleton for complex cards or grid items.
 */
export function CardSkeleton() {
  return (
    <div className="p-6 border border-gray-100 rounded-2xl bg-white space-y-4">


      <Skeleton className="h-10 w-10 rounded-xl" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-6 w-full" />
      </div>
      <Skeleton className="h-20 w-full" />
      <div className="pt-4 border-t border-gray-50 flex justify-between">


        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-4" />
      </div>
    </div>
  );
}
